// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1Xhgp","buttons":"SendReceipts_buttons__1YCwo","email":"SendReceipts_email__1OHLc","bookApptTitle":"SendReceipts_bookApptTitle__2zVa1"};